const XCompany = (props: { fill: string }) => {
	return (
		<>
			<path
				d="M13.3319 11.1225L18.5437 5H17.3087L12.7833 10.3161L9.16883 5H5L10.4657 13.0389L5 19.4592H6.2351L11.0141 13.8453L14.8312 19.4592H19L13.3316 11.1225H13.3319ZM11.6403 13.1097L11.0865 12.3092L6.68013 5.93962H8.57717L12.1331 11.0801L12.6869 11.8806L17.3093 18.5624H15.4122L11.6403 13.11V13.1097Z"
				fill={props.fill}
			/>
		</>
	);
};

export default XCompany;
